import { Damage, NewDamageReport } from 'api/types'
import { FormDamage, FormDamageReport } from './types'

const serializeDamage = (damage: FormDamage): Damage => {
  const { hadWindow, hadOther, ...damageFields } = damage
  return {
    ...damageFields,
    window: hadWindow ? damageFields.window : null,
    other: hadOther ? damageFields.other : null,
  }
}

const serializeDateTime = (date: string, time: string) => {
  const timeZoneOffset = new Date().getTimezoneOffset()
  const dif = timeZoneOffset < 0 ? '+' : '-'
  const [tzHour, tzMin] = [
    `${Math.floor(Math.abs(timeZoneOffset) / 60)}`.padStart(2, '0'),
    `${Math.abs(timeZoneOffset) % 60}`.padStart(2, '0'),
  ]
  return `${date}T${time}:00${dif}${tzHour}:${tzMin}`
}

export const serializeDamageReport = (
  form: FormDamageReport
): NewDamageReport => {
  const damageReport: NewDamageReport = {
    licensePlate: form.licensePlate,
    occurredAt: serializeDateTime(form.date, form.time),
    street: form.street,
    postcode: form.postcode,
    city: form.city,
    description: form.description,
    policeReport: form.hadPoliceReport ? form.policeReport : null,
    vehicleLocation:
      form.vehicleDrivable === false ? form.vehicleLocation : null,
    reporterIsDriver: !!form.reporterIsDriver,
    driver: form.reporterIsDriver
      ? null
      : {
          name: `${form.driver.firstName} ${form.driver.lastName}`,
          street: form.driver.street,
          postcode: form.driver.postcode,
          city: form.driver.city,
          phone: form.driver.phone,
          birthday: form.driver.birthday,
          permission: form.driver.hadPermission ? form.driver.permission : null,
          licenseAware: !!form.driver.licenseAware,
        },
    driverHadLicense: !!form.driverHadLicense,
    driverDrugs: form.driverHadDrugs ? form.driverDrugs : null,
    damage: serializeDamage(form.damage),
    multipleVehicles: !!form.multipleVehicles,
    otherVehicleLicensePlate: form.multipleVehicles
      ? form.otherVehicleLicensePlate
      : null,
    otherVehicleDamage: form.multipleVehicles
      ? serializeDamage(form.otherVehicleDamage)
      : null,
    hadTrailer: !!form.hadTrailer,
    otherDamages: form.hadOtherDamages ? form.otherDamages : null,
  }

  return damageReport
}
